import { createAction } from '@reduxjs/toolkit';

import { ThirdPartyIdProvider } from '@app/constants/IdProvider';

export const thirdPartySignInSuccess = createAction(
  'ACCOUNT_THIRD_PARTY_SIGN_IN_SUCCESS',
  (redirectTo?: string) => ({
    payload: { redirectTo },
  })
);
export const thirdPartySignInFailure = createAction(
  'ACCOUNT_THIRD_PARTY_SIGN_IN_FAILURE',
  (payload: { code: string; message: string; provider: ThirdPartyIdProvider }) => ({
    payload,
  })
);

export const thirdPartySignUpSuccess = createAction(
  'ACCOUNT_THIRD_PARTY_SIGN_UP_SUCCESS',
  (payload: { provider: ThirdPartyIdProvider }) => ({
    payload,
  })
);
export const thirdPartySignUpFailure = createAction(
  'ACCOUNT_THIRD_PARTY_SIGN_UP_FAILURE',
  (payload: { message: string; provider: ThirdPartyIdProvider; failureEmail?: string }) => ({
    payload,
  })
);

export type AccountThirdPartyAction =
  | ReturnType<typeof thirdPartySignInSuccess>
  | ReturnType<typeof thirdPartySignInFailure>
  | ReturnType<typeof thirdPartySignUpSuccess>
  | ReturnType<typeof thirdPartySignUpFailure>;
